module.exports = __webpack_public_path__ + "static/media/iconoScoreGrisCruz.9d6e55e7.svg";